import $ from 'jquery';

import Error from './error';
import words from './words';

class ApplicationFormBase {


  extraData() {
    return {};
  }

  test(data) {

    data.forEach( section => {

      switch(section.type) {
        case "radio":
          section.answer = Math.floor(Math.random() * section.answers.length)
          break;
        case "checkboxes":

          break;
        case "inputgroup":
          section.answer.forEach(obj => {
            obj.value = words((Math.random() * 3) + 1);
          })
          break;
        case "text":
        case "area":
          section.answer =  words((Math.random() * 4) + 1);
          break;
        case "group":
          section.questions.forEach(q => {
            switch(q.type) {
              case "radio":
                q.answer = Math.floor(Math.random() * q.names.length);
                break;
              case "area":
                q.answer =  words(40 + (Math.random() * 3) + 1);
                break;
              case "calendar":
                q.answer = new Date().toString();
                break;
              case "text":
                q.answer =  words((Math.random() * 3) + 1);
                break;
              case "sku":
                let rows = 1 + (Math.random() * 5);
                let total = q.columns.length;

                for (let i = 0; i < rows; i++) {
                  let row = [];
                  for (let n = 0; n < total; n++) {
                    row.push({value: words(1 + (Math.random() * 3))});
                  }
                  q.answer.push(row);
                }

                for (let n = 0; n < total; n++) {
                  q.answer[0][n].value = words(1 + (Math.random() * 3));
                }

                break;

            }
          })
          break;
        case "company":
          section.questions.forEach(obj => {
            if (obj.type == "text") {
              obj.answer =  words((Math.random() * 3) + 1);
            }
            if (obj.type == "radio") {
              obj.answer = Math.floor(Math.random() * obj.answers.length);
            }
          })
          break;
        case "person":
          section.questions.forEach(q => {
            switch(q.type) {
              case "radio":
                q.answer = Math.floor(Math.random() * q.answers.length);
                break;
              case "email":
                q.answer = "email@example.com";
                break;
              case "text":
                q.answer =  words((Math.random() * 3) + 1);
                break;

            }
          })
          break;
      }


    })

    return data;
  }

  init(data) {

    let dataObject = {
      form: (data.data),
      terms: data.terms,
      valid: false,
      termsAccepted: false,
      firstLoad: data.firstLoad,
      displayErrors: !!data.autoHighlight,
      firstSectionValid: false,
      displayFirstErrors: false,
      admin: false,
      debug: false,
    };
    let extras = this.extraData();
    for (let el in extras) {
      dataObject[el] = extras[el];
    }

    window.autoForm = () => {
      dataObject.form = this.test(data.data);
      this.vm.$children[0].firstQuestionAnswered = true;
    };
    window.formDebug = (t=true) => {
      dataObject.debug = t;
    }

    Vue.component('application-form', () => import('../components/ApplicationForm.vue'));

    this.vm = new Vue({
      template: '<application-form :debug="debug" :admin="admin" :form="form" :terms="terms" :termsAccepted="termsAccepted" :firstLoad="firstLoad" :displayErrors="displayErrors" :valid="valid" :firstSectionValid="firstSectionValid" :displayFirstErrors="displayFirstErrors" @updateFirstSection="updateFirstSection" @validate="validate"  @accept="accept"></application-form>',
      el: "#injected_form",
      data: dataObject,
      methods: {
        updateFirstSection(valid) {
          this.firstSectionValid = valid;
        },

        validate(valid) {
          this.valid = valid;
        },

        accept(valid) {
          this.termsAccepted = valid;
        }


      }
    });

    $("#draft").click(e => {
      e.preventDefault();


      this.vm.displayErrors = false;
      this.vm.displayFirstErrors = false;

      // only validate the first chunk.
      // if (this.vm.firstSectionValid == false) {
      // 	this.vm.displayFirstErrors = true;
      // 	this.scrollToFirstError();
      // 	new Error(window.Lang.get("Oops!"), window.Lang.get("Please fill in the first section"), false);
      // 	return;
      // }

      this.save(data, this.vm.form, true);
    });

    $("#save").click(e => {
      e.preventDefault();

      if (this.vm.valid === false && this.vm.admin === false) {
        this.vm.displayErrors = true; // scroll to it.
        this.scrollToFirstError();
        new Error(window.Lang.get("Oops!"), window.Lang.get("Please fill in all required fields"), true);
        return;
      }

      if (this.vm.termsAccepted === false && this.requiresTerms()) {
        this.vm.displayErrors = true; // scroll to it.
        this.scrollToTerms();
        new Error(window.Lang.get("Oops!"), window.Lang.get("Please accept the terms and conditions"), false);
        return;
      }

      this.save(data, this.vm.form, false);
    });

  }

  scrollToTerms() {
    $('html, body').animate({
      scrollTop: $(document).height()
    }, 500);
  }

  scrollToFirstError() {
    setTimeout(() => {
      let min = $(document).height();
      let element = null;
      $(".error, .group-error").each((i, el) => {

        let pos = $(el).offset().top;
        if (pos !== 0 && pos < min) {
          element = el;
          min = pos;
        }

      });

      $('html, body').animate({
        scrollTop:  min - 150
      }, 500);
    }, 200);

  }

  requiresTerms() {
    return false;
  }

  save(initial, contents, draft) {

    console.log("ERROR", "Stub function called");

  }



}

export default ApplicationFormBase;
